import { Button, Modal, Text } from "@marketplace/ui";
import { notifications } from "@marketplace/ui/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { automationDeleteModalAtom } from "../../atoms/automation-delete-modal-atom";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { useDeleteAutomationMutation } from "../../hooks/mutations/use-delete-automation-mutation";

export const AutomationDeleteModal = () => {
  const { visible, automation } = useAtomValue(automationDeleteModalAtom);
  const resetModal = useResetAtom(automationDeleteModalAtom);
  const queryClient = useQueryClient();
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("product", {
    keyPrefix: "automation.listPage.deleteModal"
  });

  const { mutate, isPending } = useDeleteAutomationMutation({
    options: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: AutomationQueryKeys.getAutomationList._def
        });
        notifications.show({
          message: t("successMessage")
        });
        resetModal();
      }
    }
  });

  const handleDelete = () => {
    if (!automation) return;
    mutate({ id: automation.id });
  };

  return (
    <Modal.Root opened={visible} onClose={resetModal} size={345}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body classNames={{ body: "!p-6" }}>
          <Text
            type="heading"
            size="xxs"
            weight="semibold"
            className="text-center text-fjord-grey-500 mb-1"
          >
            {t("title")}
          </Text>
          <Text
            type="paragraph"
            size="s"
            className="text-center text-fjord-grey-400 mb-6"
          >
            {t("description")}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button variant="secondary" fullWidth onClick={resetModal}>
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleDelete}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
